<template>
  <section id="loginPage" class="is-medium">
    <div class="columns is-gapless is-centered">
      <div class="column hero is-fullheight is-two-fifths-desktop is-half-tablet">
        <div class="hero-body">
          <article class="is-rounded">
            <form novalidate @submit.prevent="validateUser">
              <div class="card-content">
                <h1 class="title">
                  <a href="/home">
                    <img alt="logo" class="menu-logo" src="/static/img/new/menu/logo@3x.png"/>
                  </a>
                </h1>
                <flash-message size="is-size-7"></flash-message>
                <p class="control">
                  <input v-model="form.email" :disabled="sending" class="input" name="email"
                         placeholder="Enter your email"
                         type="email"/>
                </p>
                <p class="control has-icons-rightt">
                  <vue-password v-model="form.password" :disableStrength="disableStrength" classes="input password"
                                placeholder="Password"></vue-password>
                </p>
                <div class="is-flex flex-wrap-wrap">
                  <p id="forgot-pwd" class="control">
                    <a class="link-with-underline" href="forgot-password">Forgot password?</a>
                  </p>
                  <p class="control width-100">
                    <button
                      id="loginButton"
                      :class="[{ 'is-loading': sending}, 'button', 'loginButton']"
                      class="is-button-bluew"
                      type="submit">SIGN IN
                    </button>
                  </p>
                </div>
                <p id="footer" class="control">
                  <span
                    class="has-text-weight-bold font-size-14 color-404040">Need a Hellopeter business account?</span><br/>
                  <router-link class="link-with-underline font-size-14 margin-top-9 is-block"
                               to="/onboard/create/free/monthly">Create one now
                  </router-link>
                </p>
              </div>
            </form>
          </article>
        </div>
      </div>
      <div
        :class="['column hero is-fullheight is-hidden-mobile', specialEvent, { 'column-with-bg' : !specialEvent }, { 'column-with-bg-special' : specialEvent }]">
        <div v-if="!specialEvent" id="launch-text" class="is-hidden-mobile">
          <p class="season-grey-text">
            <a href="https://blog.hellopeter.com/reviews/why-business-reviews-are-the-gift-that-keeps-on-giving"
               target="_blank">Find
              out why</a>
          </p>
          <p class="season-pink-text">
            <a href="https://blog.hellopeter.com/reviews/why-business-reviews-are-the-gift-that-keeps-on-giving"
               target="_blank">reviews</a>
          </p>
          <p class="season-grey-text third">
            <a href="https://blog.hellopeter.com/reviews/why-business-reviews-are-the-gift-that-keeps-on-giving"
               target="_blank">are a
              year-round gift for your</a>
          </p>
          <p class="season-grey-text fourth ">
            <a href="https://blog.hellopeter.com/reviews/why-business-reviews-are-the-gift-that-keeps-on-giving"
               target="_blank">business
              during the holidays</a>
          </p>
          <div class="gift-image">
            <a href="https://blog.hellopeter.com/reviews/why-business-reviews-are-the-gift-that-keeps-on-giving"
               target="_blank">
              <img src="/static/img/sign_in/hands.png"/>
            </a>
          </div>
        </div>
         <img v-else :src="`/static/img/sign_in/${specialEventImg}`"/>
      </div>
    </div>
  </section>
</template>
<!-- <script type="text/babel"> -->
<script>
/* eslint-disable indent,no-new,no-undef */
import ApiResource from '../api/ApiResource'
import VuePassword from 'vue-password'
import FlashMessage from '../components/FlashMessageStrip'
import misc from '../mixins/misc.js'
import axios from 'axios'

export default {
  metaInfo: {
    title: 'Business Portal | Hellopeter - Login',
    meta: process.env.NODE_ENV === 'production' ? [
      {
        'name': 'google-site-verification',
        'content': 'PGI8Df1akrJLYTmKQbUvveOzq-oORVhABnox7YB30zE'
      }
    ] : []
  },
  components: {
    VuePassword,
    FlashMessage
  },
  mixins: [misc],
  created () {
    localStorage.clear()
    if (typeof window.Intercom !== 'undefined') {
      window.Intercom('shutdown')
    }
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Login'
    })
    this.has_notification = typeof this.$route.query.notification !== 'undefined' && this.$route.query.notification.length > 0
    /** If user's session expired somehow */
    if (this.$route.query.sessionExpired) {
      flash('You have been signed out because another active session was initiated on a different device.', 'is-danger')
    }
    /** If user is suspended somehow */
    if (this.$route.query.isSuspended) {
      flash('You account has been suspended. Please connect with admin.', 'is-danger')
    }
    /** If invite is revoked or accepted */
    if (this.$route.query.invite === 'revoked') {
      flash('This invite is no longer valid. Please speak to the admin of your Business Account.', 'is-danger')
    } else if (this.$route.query.invite === 'accepted') {
      flash('This invite has already been used. Please login using your username and password.', 'is-danger')
    }
  },
  data () {
    return {
      disableStrength: true,
      sending: false,
      has_errors: false,
      has_notification: false,
      email: '',
      password: '',
      errors: {},
      errorText: '',
      form: new ApiResource({
        email: '',
        password: ''
      }),
      specialEvent: 'industry_renewed' // fb_launch, black_friday_2023, new_year_2023
    }
  },
  watch: {
    has_errors () {
      if (this.form.errors.any()) {
        Object.keys(this.errors).map((key) => {
          flash(this.errors[key][0], 'is-danger')
        })
      }
    },
    has_notification () {
      if (this.has_notification) {
        flash(this.$route.query.notification)
      }
    }
  },
  computed: {
    specialEventImg () {
      let img = ''
      switch (this.specialEvent) {
        case 'fb_launch':
          img = 'fb_launch_text.png'
          break
        case 'black_friday_2023':
          img = 'bf-2023-login@2x.png'
          break
        case 'black_friday_2024':
          img = 'bf-2024-login@2x.png'
          break
        case 'new_year_2023':
          img = 'new_year_2023_content.png?3'
          break
        case 'industry_renewed':
          img = 'industry_content.png'
          break
      }
      return img
    }
  },
  methods: {
    getErrorMessage () {
      return this.form.errors.getDefaultErrorMessage()
    },
    /**
     * Processes login request
     * @returns {void}
     */
    validateUser () {
      this.sending = true
      this.has_errors = false
      this.form.errors.clear(null)

      this.form.send('/auth/login')
        .then((response) => {
          const isAdminMenuActive = this.$route.query.isadminactive === 'true'
          localStorage.clear()
          if (typeof window.Intercom !== 'undefined') {
            window.Intercom('shutdown')
          }
          this.sending = false
          localStorage.setItem('auth_token', this.form.token)
          this.$cookie.set('token', this.form.token, '1d')
          localStorage.setItem('is_ops', JSON.parse(this.form.is_ops))
          localStorage.setItem('first_name', this.form.first_name)
          localStorage.setItem('last_name', this.form.last_name)
          localStorage.setItem('email', this.form.email)
          localStorage.setItem('mobile_number', this.form.mobile_number)
          this.form.roles = this.form.roles.map(role => {
            role.org_name = decodeURIComponent(escape(role.org_name))
            return role
          })
          localStorage.setItem('roles', JSON.stringify(this.form.roles))
          localStorage.setItem('is_hp_admin', JSON.parse(this.form.is_hp_admin))
          localStorage.setItem('can_add_more_users', JSON.parse(this.form.can_add_more_users))
          localStorage.setItem('org_slug', response.org_slug)
          localStorage.setItem('user_id', response.user_id)
          localStorage.setItem('is_admin_menu_active', isAdminMenuActive)
          localStorage.setItem('user_hash', response.user_hash)
          if (typeof response.first_login !== 'undefined' && response.first_login) {
            this.$gtm.trackEvent({
              event: 'FirstTimeLogin'
            })
          }
          this.setDefaultBusiness(this.form.roles)
          const email = localStorage.getItem('email')
          const firstName = localStorage.getItem('first_name')
          const lastName = localStorage.getItem('last_name')
          const fullName = `${firstName} ${lastName}`.trim()
          const createdAt = localStorage.getItem('org_join_date')
          const userHash = localStorage.getItem('user_hash')
          window.Intercom('boot', {
            app_id: process.env.INTERCOM_ID,
            name: `${fullName}`,
            email: `${email}`,
            user_hash: userHash,
            created_at: createdAt
          })
          axios.get(`/${response.org_slug}/billing-details`)
            .then(({data}) => {
              localStorage.setItem('billingDetails', JSON.stringify(data))

              // push GTM event
              this.$gtm.trackEvent({
                event: 'conversionSuccess',
                type: 'Login'
              })

              let url
              if (this.$route.query.redirect) {
                url = this.$route.query.redirect
              } else if (localStorage.is_admin_menu_active === 'true' && localStorage.is_hp_admin === 'true') {
                url = '/reviews-listing'
              } else {
                url = '/'
              }
              this.$router.replace(url)
            })
            .catch((error) => {
              console.log('get billing details error', error)
            })
        })
        .catch((response) => {
          if (typeof response.error === 'string' || response.error instanceof String) {
            this.errors = {
              email: [response.error]
            }
          } else {
            this.errors = response.errors
          }
          this.sending = false
          this.has_errors = true
        })
    }
  }
}
</script>
<style>
html {
  overflow-y: auto;
}

#loginPage .control {
  margin-bottom: 10px;
  margin-top: 30px;
}

#loginPage article {
  max-width: 450px;
  margin-left: auto;
  margin-right: auto;
  box-shadow: none;
}

.link-with-underline {
  color: #30AAE1;
  text-decoration: underline;
}

#loginPage input {
  border-radius: 0 !important;
  border: 1px solid #dbdbdb !important;
  box-shadow: none !important;
  height: 3em;
}

.column-with-bg {
  background-image: url("/static/img/sign_in/hand_and_BG_separate.png");
  background-size: cover;
}

.columns.is-gapless > .column.column-with-bg-special {
  align-items: center;
  justify-content: center;
  background-size: cover;
  padding: 0 10px !important;
}

.column-with-bg-special.black_friday_2023 {
  background-image: url('/static/img/sign_in/bf-2023-login-bg@2x.png');
  height: 100vh;
}

.column-with-bg-special.black_friday_2023 img {
  max-height: 100%;
}

.column-with-bg-special.black_friday_2024 {
  background-image: url('/static/img/sign_in/bf-2024-login@2x.png');
  height: 100vh;
}

.column-with-bg-special.black_friday_2024 img {
  max-height: 100%;
}

.column-with-bg-special.new_year_2023 {
  background-image: url('/static/img/sign_in/new_year_2023_bg.jpg');
}

.column-with-bg-special.new_year_2023 img {
  width: 587px;
}

.column-with-bg-special.fb_launch {
  background-image: url('/static/img/sign_in/fb_launch.jpg?1');
}

.column-with-bg-special.fb_launch img {
  width: 720px;
}

.column-with-bg-special.industry_renewed {
  background-image: url('/static/img/sign_in/industry_bg.png');
}

.column-with-bg-special.industry_renewed img {
  width: 504px;
}

#loginPage button:not(.loginButton) {
  border: 0;
  border-radius: 0;
  height: 3em;
}

#loginPage a.VuePassword__Toggle {
  color: gray !important;
}

#loginPage .card-content {
  max-width: 348px;
  width: 100%;
  margin: 0px auto;
}

@media screen and (max-width: 768px) {
  #loginPage .column:not(:first-child) p {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

.season-grey-text a {
  font-size: 17px;
  color: #6d6e71;
  font-family: "Open Sans";
  font-weight: 400;
}

.season-pink-text a {
  font-size: 53px;
  color: #fc7f98;
  font-family: "Open Sans";
  font-weight: 700;
  line-height: 65px;
}

div#launch-text {
  padding-top: 15%;
  padding-left: 15%;
  min-height: 100%;
  overflow: hidden;
  position: relative;
}

.gift-image {
  position: absolute;
  bottom: 1%;
  right: 0;
}

.gift-image img {
  transform: rotate(-45deg);
  float: right;
  margin-right: -16px;
}

p.season-pink-text {
  margin-bottom: 4%;
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .season-grey-text a {
    font-size: 20px;
  }

  .season-pink-text a {
    font-size: 56px;
    line-height: 50px;
  }

  .gift-image img {
    width: 375px !important;
  }

  p.season-pink-text {
    margin-bottom: 1%;
  }

  div#launch-text {
    padding-top: 22%;
  }
}

@media screen and (min-width: 1200px) {
  .season-grey-text a {
    font-size: 30px;
  }

  .season-pink-text a {
    font-size: 90px;
  }

  div#launch-text {
    padding-top: 10%;
    padding-left: 10%;
  }

  p.season-pink-text {
    margin-bottom: 1.5%;
  }

  .season-pink-text a {
    line-height: 75px;
  }
}

@media screen and (max-width: 768px) {
  div#launch-text {
    padding-top: 35%;
  }

  .season-grey-text a {
    line-height: 25px;
  }
}

div#launch-text {
  overflow: hidden;
  position: relative;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  display: block;
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -ms-flex-negative: 1;
  flex-shrink: 1;
  min-height: 100vh;
}

</style>
<style scoped>
#forgot-pwd {
  margin-top: 21px;
  margin-left: 15px;
  margin-bottom: 0;
  width: 100%;
}

#loginPage .card-content > .control:first-of-type {
  margin-bottom: 47px;
  margin-top: 10px;
}

#loginPage .card-content {
  padding: 0 11px 0 12px;
  max-width: 358px;
}

#loginPage article {
  width: 100%;
}

.link-with-underline {
  color: #2c80ed;
  font-size: 13px;
}

#loginPage >>> input {
  border-radius: 7px !important;
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.07) !important;
  border: 0.5px solid rgba(36, 71, 105, 0.32) !important;
  font-size: 13px;
  padding: 9px 10px 10px 42px;
  height: auto;
  color: #666;
}

#loginPage input[type="email"] {
  background: url("/static/img/email.svg") 15px 13px no-repeat;
}

#loginPage >>> input.password {
  background: url("/static/img/password.svg") 15px 7px no-repeat;
}

section#loginPage >>> a.VuePassword__Toggle {
  color: #d2d2d2 !important;
}

#loginPage .card-content > p.control:last-child {
  margin-top: 100px;
}

#loginPage .title {
  margin-bottom: 3.2rem;
}

.title img {
  width: 166px;
}

@media screen and (max-width: 768px) {
  #loginPage >>> input {
    box-shadow: -5px 5px 10px 0 rgba(0, 0, 0, 0.07) !important;
    font-size: 14px;
  }

  #loginPage input[type="email"], #loginPage >>> input.password {
    background-size: 16px;
  }

  #loginPage input[type="email"] {
    background-position: 14px 11px;
    padding-top: 8px;
    padding-left: 43px;
    padding-bottom: 5px;
  }

  #loginPage >>> input.password {
    padding-top: 7px;
    padding-bottom: 6px;
    padding-left: 43px;
    background-position: 14px 7px;
  }

  section#loginPage >>> a.VuePassword__Toggle {
    color: #909ea9 !important;
  }

  #loginPage #forgot-pwd {
    order: 2;
    text-align: center;
    margin-top: 10px;
  }

  #footer {
    font-size: 12px !important;
    text-align: center;
  }

  #footer * {
    font-size: 12px !important;
  }

  #loginPage .title {
    margin-bottom: 43px;
    text-align: center;
  }

  #loginPage .card-content > .control:first-of-type {
    margin-bottom: 0;
  }

  #loginPage .control {
    margin-top: 21px;
    margin-bottom: 0;
  }

  #loginPage .card-content > p.control:last-child {
    margin-top: 94px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue